(function(angular) {
    angular
        .module('repairforms.constant.module')
        .constant('STATE_REQUEST', STATE_REQUEST());

    function STATE_REQUEST() {
        return {
            REQUEST: {
                name: 'request',
                url: '/request',
                templateUrl: 'view/request/wizard',
                controller: 'requestWizardController as vm',
                resolve: {
                    wizard: ['$state', '$uibModal', '$window', function($state, $uibModal, $window) {
                        return {
                            step: {
                                title: '',
                                current: undefined,
                                length: 5,
                                finishState: 'request-summary',
                                list: ['request.customer', 'request.product', 'request.location', 'request.return', 'request.review'],
                                next: function() {
                                    var self = this;
                                    if (this.beforeNext) {
                                        this.beforeNext()
                                            .then(function(data) {
                                                if (!data.validationErrors) {
                                                    self.beforeNext = undefined;
                                                    $state.go(self.list[self.current + 1] || self.finishState, {requestId: data.requestId});
                                                } else {
                                                    $uibModal
                                                        .open({
                                                            animation: true,
                                                            templateUrl: 'view/modals/repair-request-validation-errors-modal',
                                                            controller: 'repairRequestValidationErrorsModal as vm',
                                                            size: 'md',
                                                            resolve: {
                                                                validationErrors: function() {
                                                                    return data.validationErrors;
                                                                }
                                                            }
                                                        });
                                                }
                                            })
                                    } else {
                                        $state.go(self.list[self.current + 1] || self.finishState);
                                    }

                                    $window.scrollTo(0, 0);

                                },
                                beforeNext: undefined,
                                form: undefined
                            },
                            customer: {},
                            tools: [],
                            location: {},
                            returnOption: {},
                            customerNewAddresses: [],
                            customerNewAddressesLastId: 0,
                            displayedLocations: [],
                            productsChanged: false,
                            cordlessCount: 0
                        };
                    }],
                    locations: function() {
                        return [];
                    },
                    principal: ['Principal', function(Principal) {
                        return Principal.identity();
                    }],
                    countries: ['Dictionary', function(Dictionary) {
                        return Dictionary.country();
                    }],
                    usProvinces: ['Dictionary', function(Dictionary) {
                        return Dictionary.usProvince();
                    }],
                    caProvinces: ['Dictionary', function(Dictionary) {
                        return Dictionary.caProvince();
                    }],
                    toolCategories: ['Dictionary', function(Dictionary) {
                        return Dictionary.toolCategory();
                    }],
                    modelNumbers: ['Dictionary', function(Dictionary) {
                        return Dictionary.modelNumber();
                    }],
                    toolTypes: ['Dictionary', function(Dictionary) {
                        return Dictionary.toolType();
                    }],
                    purchaseOrigins: ['Dictionary', function(Dictionary) {
                        return Dictionary.purchaseOrigin();
                    }],
                    userRegisteredProducts: ['ProductService', '$uibModal', '$state', 'principal', '$q', function(ProductService, $uibModal, $state, principal, $q) {
                        return principal && !!principal.login ? getRegisteredTools() : $q.resolve([]);

                        function getRegisteredTools() {
                            return ProductService
                                .getRegisteredTools()
                                .then(function (response) {
                                    if (!response.data.validationErrors){
                                        return response.data;
                                    } else {
                                        $uibModal
                                            .open({
                                                animation: true,
                                                templateUrl: 'view/modals/repair-services-unavailable-modal',
                                                controller: 'repairServicesUnavailableModal as vm',
                                                size: 'md',
                                                resolve: {
                                                    validationErrors: function() {
                                                        return response.data.validationErrors;
                                                    }
                                                }
                                            });
                                        $state.go('dashboard');
                                    }
                                });
                        }
                    }]
                },
                params: {
                    registeredTools: undefined
                }
            },
            PRODUCT: {
                name: 'request.product',
                templateUrl: 'view/request/step_product',
                controller: 'productInformationStepController as vm',
                onEnter: ['wizard', 'RepairRequestService', 'ProductService', function(wizard, RepairRequestService, ProductService) {
                    wizard.step.title = 'product.information.and.service.request';
                    wizard.step.current = 1;
                    wizard.step.beforeNext = function() {
                        wizard.waitingForResponse = true;
                        return RepairRequestService
                            .addOrUpdateProducts(wizard.tools)
                            .then(function(response) {
                                var cordlessCount = 0;
                                for (var i=0; i<wizard.tools.length; i++){
                                    if (wizard.tools[i].cordless) {
                                        cordlessCount++;
                                    }
                                }
                                wizard.cordlessCount = cordlessCount;

                                var errors = [];
                                for(var i = 0; i<response.data.length; i++){
                                    if(response.data[i].successful){
                                        if(response.data[i].additionalData){
                                            wizard.tools[i].productId = response.data[i].additionalData;
                                        }
                                    }else{
                                        errors.push(response.data[i].validationErrors);
                                    }
                                }
                                if (errors.length > 0){
                                    var retval = {validationErrors: []};
                                    for (var i = 0; i<errors.length; i++){
                                        for(var j = 0; j<errors[i].length; j++){
                                            var alreadyIncluded = false;
                                            for(var k = 0; k<retval.validationErrors.length; k++){
                                                if(errors[i][j] == retval.validationErrors[k]){
                                                    alreadyIncluded = true;
                                                }
                                            }
                                            if(!alreadyIncluded){
                                                retval.validationErrors.push(errors[i][j]);
                                            }
                                        }
                                    }
                                    wizard.waitingForResponse = false;
                                    return retval;
                                }else{
                                    return {};
                                }
                            });
                    };
                    wizard.step.addAnotherTool = function() {
                        if (wizard.tools.length < 5) {
                            wizard.tools.push({});
                        }
                    };
                }]
            },
            CUSTOMER: {
                name: 'request.customer',
                templateUrl: 'view/request/step_customer',
                controller: 'customerInformationStepController as vm',
                onEnter: ['wizard', 'CustomerService', 'RepairRequestService', 'principal', function(wizard, CustomerService, RepairRequestService, principal) {
                    wizard.step.title = 'customer.information';
                    wizard.step.current = 0;
                    wizard.step.beforeNext = function() {
                        wizard.waitingForResponse = true;
                        if (wizard.customer.selectedAddress.addToProfile && principal && !!principal.login) {
                            CustomerService
                                .add(wizard.customer.selectedAddress)
                                .then(function (response) {
                                    wizard.customerSelectedAddressId = response.data;
                                });

                            if(wizard.customer.selectedAddress.isNew) {
                                var addressWithId = _.find(wizard.customerNewAddresses, function(customerAddress){
                                    if(customerAddress.newId == wizard.customer.selectedAddress.newId) {
                                        return customerAddress;
                                    }
                                });
                                if(!_.isEmpty(addressWithId)) {
                                    var customerAddressIndex = _.indexOf(wizard.customerNewAddresses, addressWithId);
                                    wizard.customerNewAddresses.splice(customerAddressIndex, 1);
                                }

                            }

                        } else {
                            wizard.customerSelectedAddressId = 0;
                        }
                        var addresses = [];
                        if(wizard.location && wizard.location.shippingAddress){
                            wizard.location.shippingAddress.addressType = 2;
                            addresses.push(wizard.location.shippingAddress);
                        }
                        if(wizard.returnOption && wizard.returnOption.shippingAddress){
                            wizard.returnOption.shippingAddress.addressType = 1;
                            addresses.push(wizard.returnOption.shippingAddress);
                        }
                        return RepairRequestService
                        .addOrUpdateCustomer(wizard.customer, addresses)
                        .then(function(response){
                            if (response.data.validationErrors){
                                wizard.waitingForResponse = false;
                            }
                            return response.data;
                        });
                    };

                    if(_.isEmpty(wizard.customer) && principal && !!principal.login) {
                        CustomerService
                            .current()
                            .then(function(response) {
                                wizard.customer = response.data || {};
                                wizard.customer.addresses.unshift({
                                    name: 'Add new address',
                                    addNew: true
                                });
                        });
                    } else if (principal && !!principal.login) {
                        CustomerService
                            .currentAddresses()
                            .then(function(response) {
                                wizard.customer.addresses = response.data || [];
                                wizard.customer.addresses.unshift({
                                    name: 'Add new address',
                                    addNew: true
                                });

                                wizard.customer.addresses = wizard.customer.addresses.concat(wizard.customerNewAddresses);

                                if(wizard.customerSelectedAddressId && wizard.customerSelectedAddressId != 0) {
                                    var addressWithId = _.find(wizard.customer.addresses, function(address){
                                        if(address.id == wizard.customerSelectedAddressId) {
                                            return address;
                                        }
                                    });
                                    if(!_.isEmpty(addressWithId)) {
                                        wizard.customer.selectedAddress = addressWithId;
                                    }

                                }
                            });
                    }

                }]
            },
            LOCATION: {
                name: 'request.location',
                templateUrl: 'view/request/step_location',
                controller: 'repairLocationStepController as vm',
                resolve: {
                    distances: ['Dictionary', function(Dictionary) {
                        return Dictionary.distance();
                    }],
                    productTypes: ['Dictionary', function(Dictionary) {
                        return Dictionary.productType();
                    }]
                },
                onEnter: ['wizard', 'RepairRequestService', function(wizard, RepairRequestService) {
                    wizard.step.title = 'repair.location';
                    wizard.step.current = 2;
                    wizard.step.beforeNext = function () {
                        wizard.waitingForResponse = true;
                        var totalWeight = 0;
                        angular.forEach(wizard.tools, function (tool) {
                            totalWeight += tool.productWeight;
                        });
                        wizard.location.totalWeight = Math.round(totalWeight * 1e2)/1e2;
                        return RepairRequestService
                            .addOrUpdateServiceLocation(wizard.location, wizard.returnOption.shippingAddress, wizard.customer)
                            .then(function(response){
                                if (response.data.validationErrors){
                                    wizard.waitingForResponse = false;
                                }
                                return response.data;
                            });
                    };
                }]
            },
            RETURN: {
                name: 'request.return',
                templateUrl: 'view/request/step_return',
                controller: 'returnOptionStepController as vm',
                onEnter: ['wizard', 'RepairRequestService', '$q', function(wizard, RepairRequestService, $q) {
                    wizard.step.title = 'return.of.repaired.tool';
                    wizard.step.current = 3;
                    wizard.step.beforeNext = function () {
                        var deferred = $q.defer();
                        if (wizard.returnOption.shipping == 'UPS') {
                            if (wizard.returnOption.returnAddressOption == 'CURRENT_ADDRESS'){
                                wizard.returnOption.shippingAddress = angular.copy(wizard.customer.selectedAddress);
                            }
                            wizard.waitingForResponse = true;
                            RepairRequestService
                                .addShippingAddress(wizard.customer, wizard.returnOption.shippingAddress, wizard.location.shippingAddress)
                                .then(function(response){
                                    if (response.data.validationErrors){
                                        wizard.waitingForResponse = false;
                                    }
                                    deferred.resolve(response.data);
                                });
                        } else {
                            deferred.resolve({});
                        }
                        return deferred.promise;
                    };
                }]
            },
            REVIEW: {
                name: 'request.review',
                templateUrl: 'view/request/step_review',
                controller: 'requestReviewStepController as vm',
                onEnter: ['wizard', 'RepairRequestService', '$state', function(wizard, RepairRequestService, $state) {
                    wizard.step.title = 'e.repair.form.review';
                    wizard.step.current = 4;
                    wizard.step.beforeNext = function() {
                        wizard.waitingForResponse = true;
                        return RepairRequestService
                            .submit(wizard.customer, wizard.tools, wizard.location, wizard.returnOption, wizard.location.boxCount, wizard.cordlessCount, wizard.optIn)
                            .then(function(response) {
                                if (response.data.validationErrors){
                                    wizard.waitingForResponse = false;
                                }
                                return response.data;
                            });
                    };
                }]
            }

        };
    }

})(angular);